// Polish dictionary — keep structurally identical to en.js.
const pl = {
  nav: {
    info: 'INFO',
  },

  hero: {
    subtitle: 'Przeżyj turnieje badmintona w pięknym mieście Trenczyn',
    info: 'INFO',
    book: 'ZAREZERWUJ NOCLEG',
  },

  home: {
    upcomingTitle: 'Nadchodzące wydarzenia w 2026',
    u15Card: 'SLOVAK YOUTH Badminton Europe U15 circuit',
    u17Card: 'SLOVAK YOUTH Badminton Europe U17 circuit',
    u13Card: 'SLOVAK YOUTH Badminton Europe U13 circuit',
    labelUpcoming: 'Już wkrótce',
    eventDateShort: '25–27 września',
  },

  tournament: {
    entryDeadline: 'Termin zgłoszeń:',
    upcoming: 'Już wkrótce',
    deadlineU17: '25 sierpnia 2026',
    deadlineU13: '11 września 2026',
    eventDate: '25–27 września 2026',
    invitation: 'ZAPROSZENIE',
    register: 'REJESTRACJA',
    draws: 'LOSOWANIE',
    acceptanceList: 'LISTA UCZESTNIKÓW',
    infoTitle: 'Informacje o turnieju',
    entryFees: 'Wpisowe:',
    singles25: 'Gra pojedyncza = 25 €',
    singles40: 'Gra pojedyncza = 40 €',
    doubles20: 'Gra podwójna = 20 € / zawodnik',
    doubles30: 'Gra podwójna = 30 € / zawodnik',
    feesPayment: 'Wpisowe należy opłacić przelewem bankowym przed turniejem lub gotówką (EUR) u organizatora podczas turnieju.',
    shuttlesLabel: 'Oficjalne lotki turnieju:',
    shuttlesBrand: 'KAWASAKI SHUTTLECOCK TEAM 1',
    shuttlesText: 'Na każdy mecz zostaną zapewnione 2 lotki, kolejne zawodnicy zapewniają we własnym zakresie. Lotki KAWASAKI SHUTTLECOCK TEAM 1 można kupić u organizatora.',
    managersMeeting: 'Odprawa kierowników drużyn:',
    meetingU17: 'Czwartek, 24 września 2026 o godz. 19:00 w hali.',
    mainEvent: 'Turniej główny',
    finals: 'Finały',
    provisionalNote: 'ⓘ Wstępne godziny mogą ulec zmianie w zależności od liczby zgłoszeń. Ostateczny harmonogram (z dokładnym planowanym zakończeniem wszystkich meczów) zostanie opublikowany na stronie najpóźniej 20 dni przed rozpoczęciem turnieju.',
    seedingNote: 'Rozstawienie i losowanie przeprowadzono zgodnie z rankingiem BEC European U17 z 17 września.',
    koSystemNote: 'Gry pojedyncze w pierwszej fazie rozgrywane są w grupach, następnie systemem pucharowym (KO); gry podwójne rozgrywane są systemem pucharowym. W przypadku sporu decyzja sędziego głównego jest ostateczna.',
    day25: '25 września',
    day26: '26 września',
    day27: '27 września',
  },

  info: {
    heroTitle: 'Informacje',
    contactsTitle: 'Kontakt i lokalizacja',
    director: 'Dyrektor turnieju:',
    contactPerson: 'Osoba kontaktowa:',
    phoneNumber: 'Telefon:',
    email: 'Email:',
    venue: 'Miejsce rozgrywek:',
    transportTitle: 'Transport',
    transportIntro: 'Organizator zapewnia odpłatny transport z:',
    transportDetails: 'Szczegóły podróży prześlij jak najszybciej na sj.bedminton@gmail.com. Opłaty za transport należy uiścić przelewem przed turniejem lub gotówką (EUR) u organizatora podczas turnieju.',
    transportWalking: 'Wszystkie oficjalne hotele znajdują się w odległości spaceru od hali, dlatego transport między halą a hotelami nie jest zapewniany.',
    mealsDesc: 'Restauracja znajduje się w hali. Obiady i kolacje serwowane są w formie bufetu z wyborem dań – all you can eat:',
    transportBa: 'Lotnisko BRATYSŁAWA = 30 € / osoba / w jedną stronę',
    transportVie: 'Lotnisko WIEDEŃ = 40 € / osoba / w jedną stronę',
    accomTitle: 'Noclegi',
    accomOrder: 'Nocleg zamawia się bezpośrednio przez nasz internetowy formularz rezerwacyjny.',
    accomPayment: 'Za nocleg należy zapłacić przelewem przed turniejem lub gotówką (EUR) u organizatora zaraz po przyjeździe do hali sportowej. Płaci się za pokój, nie za osobę.',
    breakfastIncluded: 'Śniadanie w cenie',
    doubleRoom85: 'Pokój 2-osobowy = 85 €/noc',
    tripleRoom100: 'Pokój 3-osobowy = 100 €/noc',
    fourRoom110: 'Pokój 4-osobowy = 110 €/noc',
    doubleRoom95: 'Pokój 2-osobowy = 95 €/noc',
    tripleRoom110: 'Pokój 3-osobowy = 110 €/noc',
    singleRoom65: 'Pokój 1-osobowy = 65 €/noc',
    apartment170: 'Apartament (2–4 osoby) = 170 €/noc',
    apartmentMinStay: 'Minimalny pobyt = 3 noce. Śniadanie w cenie.',
    apartmentDesc: 'Apartament obejmuje: 2 oddzielne pokoje 2-osobowe, łazienkę, kuchnię, salon, pralkę.',
    distVenue: 'Bezpośrednio w miejscu rozgrywek.',
    dist14: '1,4 km od hali.',
    dist19: '1,9 km od hali.',
    servicesTitle: 'Pozostałe usługi',
    stringing: 'Naciąganie rakiet:',
    stringingAvail: 'Dostępne przez cały czas trwania turnieju:',
    stringingOnly: 'Naciągnięcie = 10 €',
    stringingNew: 'Naciągnięcie + nowy naciąg = 18 €',
    meals: 'Wyżywienie:',
    lunch: 'Obiad = 12 €',
    dinner: 'Kolacja = 12 €',
  },

  booking: {
    headerTitle: 'Rezerwacja noclegu',
    headerSub: 'Slovak Junior & Youth · Trenczyn',
    step1Title: 'Wybierz turniej',
    underAge: (age) => `Do ${age} lat`,
    contactTitle: 'Dane kontaktowe',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    phone: 'Telefon',
    email: 'Email',
    emailInvalid: 'Podaj prawidłowy adres e-mail',
    selectCountry: 'Wybierz kraj',
    searchCountry: 'Szukaj kraju…',
    chooseHotel: 'Wybierz hotel',
    checkingAvail: 'sprawdzam dostępność…',
    availUnknown: 'Nie udało się zweryfikować dostępności — wyświetlane liczby mogą być nieaktualne.',
    unavailable: 'Brak miejsc',
    selfCatering: 'Bez wyżywienia',
    breakfast: 'Śniadanie w cenie',
    atVenue: 'W miejscu rozgrywek · 0 km',
    fromVenue14: '1,4 km od hali',
    fromVenue19: '1,9 km od hali',
    rooms: 'Pokoje',
    perNight: '€ / noc',
    addRoom: 'Dodaj pokój',
    soldOut: 'Wyprzedane',
    minNights3: 'Apartamenty wymagają minimalnego pobytu 3 nocy.',
    noRoomsLeft: 'W tym hotelu nie ma już wolnych pokoi',
    onlyRoomsLeft: (n) => `W tym hotelu ${n === 1 ? 'został już tylko 1 pokój' : `zostały już tylko ${n} pokoje`}`,
    roomsAvailable: (n, total) => `Wolne pokoje: ${n} z ${total}`,
    selectedRooms: 'Wybrane pokoje',
    remove: 'Usuń',
    checkin: 'Przyjazd',
    checkout: 'Wyjazd',
    nights: (n) => {
      if (n === 1) return '1 noc';
      const d = n % 10, h = n % 100;
      return `${n} ${d >= 2 && d <= 4 && !(h >= 12 && h <= 14) ? 'noce' : 'nocy'}`;
    },
    personFirst: (i) => i === 1 ? 'Imię (osoba 1)' : `Imię (osoba ${i}, opcjonalnie)`,
    personLast: (i) => i === 1 ? 'Nazwisko (osoba 1)' : `Nazwisko (osoba ${i}, opcjonalnie)`,
    addAnotherRoom: 'Dodaj kolejny pokój',
    summaryTitle: 'Podsumowanie rezerwacji',
    tournamentLabel: 'Turniej:',
    hotelLabel: 'Hotel:',
    contactLabel: 'Kontakt:',
    phoneLabel: 'Telefon:',
    emailLabel: 'Email:',
    person: 'Osoba',
    estimatedTotal: 'Razem',
    paymentNote: 'Płatność przelewem przed turniejem lub gotówką (EUR) przy przyjeździe. Płaci się za pokój, nie za osobę.',
    overFull: (hotel) => `${hotel} właśnie się wyprzedał — wróć i wybierz inny hotel.`,
    overSome: (n, hotel, remove) => `W hotelu ${hotel} ${n === 1 ? 'został już tylko 1 pokój' : `zostały już tylko ${n} pokoje`} — usuń ${remove} ${remove === 1 ? 'pokój' : 'pokoje'} lub wybierz inny hotel.`,
    btnContact: 'Dane kontaktowe',
    btnHotel: 'Wybierz hotel',
    btnRoom: 'Wybierz pokój',
    btnGuests: 'Dodaj gości',
    btnReview: 'Podsumowanie i wysyłka',
    btnSubmit: 'Wyślij rezerwację',
    btnSubmitting: 'Wysyłanie…',
    btnBack: 'Wstecz',
    btnClose: 'Zamknij',
    successTitle: 'Rezerwacja wysłana!',
    successText: 'Twoje zgłoszenie noclegu zostało przyjęte. Organizator je potwierdzi i wyśle instrukcje płatności na Twój e-mail.',
    confirmHotelChange: 'Zmiana hotelu usunie wybrane pokoje. Kontynuować?',
    submitError: 'Przepraszamy, podczas wysyłania rezerwacji wystąpił błąd. Spróbuj ponownie.',
    roomTypes: {
      'Single room': 'Pokój 1-osobowy',
      'Double room': 'Pokój 2-osobowy',
      'Triple room': 'Pokój 3-osobowy',
      '4-person room': 'Pokój 4-osobowy',
      'Apartment (2-4 persons)': 'Apartament (2–4 osoby)',
    },
  },

  reg: {
    notOpen: 'Rejestracja nie została jeszcze otwarta.',
    headerTitle: 'Rejestracja na turniej',
    step1Title: 'Klub i kontakt',
    club: 'Nazwa klubu',
    country: 'Kraj',
    managerTitle: 'Kierownik drużyny',
    singlesTitle: 'Zgłoszenia — gry pojedyncze',
    doublesTitle: 'Zgłoszenia — gry podwójne',
    addSingles: 'Dodaj zawodnika do gry pojedynczej',
    addDoubles: 'Dodaj parę do gry podwójnej',
    noEntries: 'Brak zgłoszeń — możesz pominąć ten krok.',
    player1: 'Zawodnik 1',
    player2opt: 'Zawodnik 2 (opcjonalnie)',
    partnerNote: 'Zgłoszenie do gry podwójnej jest ważne także z jednym zawodnikiem — partnera można dodać później.',
    discipline: 'Konkurencja',
    disciplines: {
      BS: 'Gra pojedyncza — chłopcy',
      GS: 'Gra pojedyncza — dziewczęta',
      BD: 'Gra podwójna — chłopcy',
      GD: 'Gra podwójna — dziewczęta',
      XD: 'Gra mieszana',
    },
    summaryTitle: 'Podsumowanie rejestracji',
    clubLabel: 'Klub:',
    entriesLabel: 'Zgłoszenia:',
    entriesCount: (n) => {
      if (n === 1) return '1 zgłoszenie';
      const d = n % 10, h = n % 100;
      return `${n} ${d >= 2 && d <= 4 && !(h >= 12 && h <= 14) ? 'zgłoszenia' : 'zgłoszeń'}`;
    },
    needOneEntry: 'Przed wysłaniem dodaj co najmniej jedno zgłoszenie (gra pojedyncza lub podwójna).',
    btnSingles: 'Gry pojedyncze',
    btnDoubles: 'Gry podwójne',
    btnSubmit: 'Wyślij rejestrację',
    successTitle: 'Rejestracja wysłana!',
    successText: 'Twoje zgłoszenia zostały przyjęte. Organizator potwierdzi rejestrację e-mailem.',
  },
};

export default pl;
